<template>
  <v-card flat class="transparent" v-if="items && items.length > 0">
    <v-card-text class="px-0 py-1 align-items-center">
      <v-icon small left color="accent">mdi-shield-outline</v-icon>
      <v-btn small depressed text dark color="secondary" v-for="(item, i) in items" :key="'c'+i" v-html="item.name" :href="'/' + item.slug"></v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'PostCategories',

    props: ['items']
  }
</script>